var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5949_2975",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5949_2975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.23818 17.834V9.19113H1.66675V4.47684H5.75246C5.68699 4.35898 5.64443 4.23458 5.62478 4.10363C5.60514 3.97267 5.59532 3.83517 5.59532 3.69113C5.59532 3.03637 5.82449 2.47982 6.28282 2.02148C6.74115 1.56315 7.2977 1.33398 7.95246 1.33398C8.25365 1.33398 8.5352 1.38964 8.7971 1.50095C9.05901 1.61226 9.30127 1.76613 9.52389 1.96256C9.74651 1.75303 9.98877 1.59589 10.2507 1.49113C10.5126 1.38637 10.7941 1.33398 11.0953 1.33398C11.7501 1.33398 12.3066 1.56315 12.765 2.02148C13.2233 2.47982 13.4525 3.03637 13.4525 3.69113C13.4525 3.83517 13.4394 3.9694 13.4132 4.09381C13.387 4.21821 13.3477 4.34589 13.2953 4.47684H17.381V9.19113H15.8096V17.834H3.23818ZM11.0953 2.90541C10.8727 2.90541 10.6861 2.98071 10.5355 3.13131C10.3849 3.2819 10.3096 3.46851 10.3096 3.69113C10.3096 3.91375 10.3849 4.10035 10.5355 4.25095C10.6861 4.40154 10.8727 4.47684 11.0953 4.47684C11.3179 4.47684 11.5045 4.40154 11.6551 4.25095C11.8057 4.10035 11.881 3.91375 11.881 3.69113C11.881 3.46851 11.8057 3.2819 11.6551 3.13131C11.5045 2.98071 11.3179 2.90541 11.0953 2.90541ZM7.16675 3.69113C7.16675 3.91375 7.24205 4.10035 7.39264 4.25095C7.54324 4.40154 7.72984 4.47684 7.95246 4.47684C8.17508 4.47684 8.36169 4.40154 8.51228 4.25095C8.66288 4.10035 8.73818 3.91375 8.73818 3.69113C8.73818 3.46851 8.66288 3.2819 8.51228 3.13131C8.36169 2.98071 8.17508 2.90541 7.95246 2.90541C7.72984 2.90541 7.54324 2.98071 7.39264 3.13131C7.24205 3.2819 7.16675 3.46851 7.16675 3.69113ZM3.23818 6.04827V7.6197H8.73818V6.04827H3.23818ZM8.73818 16.2626V9.19113H4.80961V16.2626H8.73818ZM10.3096 16.2626H14.2382V9.19113H10.3096V16.2626ZM15.8096 7.6197V6.04827H10.3096V7.6197H15.8096Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAward);
export default __webpack_public_path__ + "static/media/Award.a4f254b224566c183909c92d5d9c79fe.svg";
export { ForwardRef as ReactComponent };